"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrAutocompleteMobileModal = void 0;
const next_i18next_1 = require("next-i18next");
const react_1 = __importDefault(require("react"));
const components_common_modals_1 = require("@hotelplan/components.common.modals");
const core_basis_bs_button_1 = require("@hotelplan/core.basis.bs-button");
const fdr_combobox_styles_1 = require("./fdr-combobox.styles");
function FdrAutocompleteMobileModal(props) {
    const { children, name, label, disableApply, show, noControls, onApply, onOpen, onClose, } = props;
    const [t] = (0, next_i18next_1.useTranslation)('common');
    return (react_1.default.createElement(fdr_combobox_styles_1.AutocompleteMobileModalWrapper, { label: label ? label : `${name} Autocomplete`, name: name, show: show, fullScreen: true, onOpen: onOpen, onClose: onClose, controls: noControls ? undefined : (react_1.default.createElement(core_basis_bs_button_1.BsButton, { variant: "applyButton", type: "button", onClick: onApply, disabled: disableApply, "data-id": "apply" }, t('common:apply'))) },
        react_1.default.createElement(components_common_modals_1.ModalContent, null, children)));
}
exports.FdrAutocompleteMobileModal = FdrAutocompleteMobileModal;
//# sourceMappingURL=fdr-combobox-mobile-modal.js.map